import { AppFixture } from '../types';

/**
 * All of our SQL apps use the same action name and need key, so this fixture applies to:
 *   - MySQLAPI
 *   - PostgreSQLAPI
 *   - MSSQLAPI
 *
 * The need with a key of `query` is given a type of `sql` in order to display a custom SQL input
 * instead of the standard `unicode` input.
 */

const fixture: AppFixture = {
  row_custom_query: {
    needs: (needs) => {
      needs.forEach((need) => {
        if (need.key === 'query') {
          need.type = 'sql';
        }
      });
      return needs;
    },
  },
};

export default fixture;
